import { ContentBlockCard, Section } from '@components';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useMediaQueries } from '@hooks';
import { useRef } from 'react';
import classnames from 'classnames';
import Link from 'next/link';

export default function Values({ list }) {
  const { isMobile } = useMediaQueries();
  const sliderRef = useRef(null);
  return (
    <Section className={'pt-8 pb-28'}>
      {isMobile ? (
        <Splide
          tag="section"
          ref={sliderRef}
          options={{
            drag: true,
            type: 'slide',
            width: '100%',
            height: '100%',
            autoplay: true,
            pagination: false,
            arrows: false,
            padding: 0,
            rewind: true,
            snap: true,
            perPage: 1,
            perMove: 1,
            focus: 0,
            flickPower: 800,
            flickMaxPages: 1,
            lazyLoad: 'nearby',
            gap: 8,
            video: {
              loop: true,
              mute: true,
            },
          }}
        >
          {list?.length > 0 &&
            list?.map(({ attributes }, i) => {
              const { img, cta } = attributes;
              return (
                <SplideSlide
                  key={i}
                  className={classnames(
                    'relative',
                    'z-10 rounded-t-sm md:rounded-sm',
                    'centered',
                  )}
                >
                  <ContentBlockCard index={i} img={img}>
                    <Link href={cta?.href}>
                      <p className="h1 text-primary hover:underline ">
                        {cta?.label}
                      </p>
                    </Link>
                  </ContentBlockCard>
                </SplideSlide>
              );
            })}
        </Splide>
      ) : (
        <>
          {list?.length > 0 &&
            list.map(({ attributes }, i) => {
              const { cta, img } = attributes;
              return (
                <ContentBlockCard index={i} key={i} img={img}>
                  <Link href={cta?.href}>
                    <p className="h1 text-primary hover:underline ">
                      {cta?.label}
                    </p>
                  </Link>
                </ContentBlockCard>
              );
            })}
        </>
      )}
    </Section>
  );
}
